import { createSlice } from "@reduxjs/toolkit";
import {
  addCategory,
  fetchCategories,
  fetchCategoryById,
  updateCategory,
  updateStatusInCategory,
  fetchCategoryDropdownForForms,
  fetchCategoryByDropDown
} from "./thunk";

interface CategoryState {
  categoryList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedCategories: any;
  categoryDropdownForForm: any[]; // Dropdown data for forms
  categoryDropdown: any[]; 
}

const initialState: CategoryState = {
  categoryList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedCategories: null,
  categoryDropdownForForm: [],
  categoryDropdown: [],
};

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categoryList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Categories";
      })
      .addCase(fetchCategoryById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategoryById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategories = action.payload;
      })
      .addCase(fetchCategoryById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addCategory.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.categoryList = state.categoryList.map((category) =>
          category.id === action.payload.id ? action.payload : category
        );
      })
      .addCase(addCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateCategory.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.categoryList = state.categoryList.map((category) =>
          category.id === action.payload.id ? action.payload : category
        );
      })
      .addCase(updateCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      // .addCase(updateStatusInCategory.fulfilled, (state, action) => {
      //   if (!action.payload?.id) return;
      //   // state.categoryList = state.categoryList.map((category) =>
      //   //   category.id === action.payload.id ? action.payload : category
      //   // );
      // })
      .addCase(updateStatusInCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      })
      .addCase(fetchCategoryDropdownForForms.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategoryDropdownForForms.fulfilled, (state, action) => {
        state.loading = false;
        state.categoryDropdownForForm = action.payload;
      })
      .addCase(fetchCategoryDropdownForForms.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string || "Failed to fetch Category dropdown";
      })
      .addCase(fetchCategoryByDropDown.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategoryByDropDown.fulfilled, (state, action) => {
        state.loading = false;
        state.categoryDropdown= action.payload.data || [];
      })
      .addCase(fetchCategoryByDropDown.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string || "Failed to fetch Category dropdown";
      });
  },
});

export default categorySlice.reducer;
